import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import SignupImage from 'assets/images/signup.jpg';
import GetVerificationCode from 'graphqlDocuments/queries/GetVerificationCode.graphql';
import { RequestVerificationEmails } from 'graphqlDocuments/mutations';
import useMe from 'utils/hooks/useMe/useMe';
import { useToast } from 'utils/hooks/useToast/useToast';
import VERIFY_EMAIL_CONFIRM from '../../graphqlDocuments/mutations/VerifyEmailConfirm.graphql';
import EmailCodeVerification from 'components/EmailCodeVerification';

const VerifyEmail: FunctionComponent = function () {
  const { t } = useTranslation(['LOGIN', 'ENTERPRISE_SIGNUP', 'SIGNUP']);
  const { me } = useMe();
  const { toast, toastErr } = useToast();

  const email = me?.email || '';

  const [verifyEmail] = useMutation(VERIFY_EMAIL_CONFIRM);
  const [requestVerificationEmail] = useMutation(RequestVerificationEmails);

  const sendVerificationEmail = useCallback(async () => {
    if (!email) return;

    await requestVerificationEmail({
      variables: {
        email,
      },
    });
  }, [email, requestVerificationEmail, toastErr]);

  return (
    <div className="content content--no-navigation">
      <div className="u-ovh">
        <div className="row justify-content-center">
          <div className="row col-12">
            <div className="col-lg-6">
              <img className="img-login-signup" src={SignupImage} alt="signup" />
            </div>

            <div className="col-12 col-sm-10 col-md-8 col-lg-4 offset-sm-1 offset-md-2 offset-lg-1 ">
              <section className="section my-8 mt-sm-6 mt-md-5">
                <h1 className="u-mb-3">{t('ENTERPRISE_SIGNUP:EMAIL_SENT_TITLE')}</h1>

                <p className="text--black">
                  {t('ENTERPRISE_SIGNUP:GET_STARTED_EMAIL_VERIFICATION')}
                </p>

                <p className="font-weight--bold h4 mb-8">{email}</p>

                <EmailCodeVerification
                  onSubmit={async ({ verificationCode }) => {
                    await verifyEmail({
                      variables: {
                        code: verificationCode,
                      },
                      refetchQueries: [
                        {
                          query: GetVerificationCode,
                        },
                      ],
                    });
                    toast({
                      title: t('SIGNUP:VERY_EMAIL_TITLE'),
                      message: t('SIGNUP:CONFIRMATION_EMAIL_CONFIRMED'),
                      type: 'success',
                    });
                  }}
                  onResend={sendVerificationEmail}
                />
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
